module.exports = __webpack_public_path__ + "static/media/guitar.fb67a135.svg";